var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-card-container"},[_c('img',{staticClass:"blog-card-image",attrs:{"alt":_vm.image_alt,"src":_vm.image_src}}),_c('h5',{staticClass:"blog-card-text"},[_vm._v(_vm._s(_vm.new_prop))]),_c('span',[_vm._v(_vm._s(_vm.description))]),_c('next-button',{attrs:{"button":"Read more"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }